import { Routes, Route } from 'react-router-dom';
// eslint-disable-next-line max-len
import { type StandardApplicationEntrypointContextDataFragment } from '../../../api/fragments/StandardApplicationEntrypointContextData';
import { useThemeComponents } from '../../../themes';
import SessionRevokedPage from '../SessionRevokedPage';
import AcknowledgementInfoPage from './AcknowledgementInfoPage';
import CustomerValidationPage from './CustomerValidationPage';
import Journey from './Journey';

export type PublicAccessEntrypointProps = {
    endpoint: StandardApplicationEntrypointContextDataFragment;
};

const PublicAccessEntrypoint = ({ endpoint }: PublicAccessEntrypointProps) => {
    const { StandardLayout } = useThemeComponents();

    return (
        <Routes>
            <Route key="authorize" element={<CustomerValidationPage layout={StandardLayout} />} path="authorize" />
            <Route key="apply" element={<Journey endpoint={endpoint} />} path="apply" />
            <Route key="sessionRevoked" element={<SessionRevokedPage />} path="sessionRevoked" />
            <Route key="thankyou" element={<AcknowledgementInfoPage />} path="thankyou" />
        </Routes>
    );
};

export default PublicAccessEntrypoint;
